/**
 * Celé kladné nebo záporné číslo, bez oddělovačů tisíců.
 */

export const SignedIntNumber = {
  overwrite: true,
  autofix: true,
  mask: Number,
  signed: true,
  scale: 0,
  thousandsSeparator: '',
  // radix: ',',
};

/**
 * Celé kladné nebo záporné číslo, české oddělovačě tisíců.
 */
export const SignedIntNumberThSep = {
  overwrite: true,
  autofix: true,
  mask: Number,
  signed: true,
  scale: 0,
  thousandsSeparator: ' ',
  // radix: ',',
};

/**
 * Celé kladné číslo, bez oddělovačů tisíců.
 */
export const UnsignedIntNumber = {
  overwrite: true,
  autofix: true,
  mask: Number,
  signed: false,
  scale: 0,
  thousandsSeparator: '',
  // radix: ',',
};

/**
 * Celé kladné číslo, bez oddělovačů tisíců.
 */
export const UnsignedIntNumberThSep = {
  overwrite: true,
  autofix: true,
  mask: Number,
  signed: false,
  scale: 0,
  thousandsSeparator: ' ',
  // radix: ',',
};

/**
 * Celé kladné nebo záporné číslo, bez oddělovačů tisíců.
 */
export const SignedFloatNumber = {
  overwrite: true,
  autofix: true,
  mask: Number,
  signed: true,
  scale: 2,
  thousandsSeparator: '',
  radix: ',',
};

/**
 * Celé kladné nebo záporné číslo, české oddělovačě tisíců.
 */
export const SignedFloatNumberThSep = {
  overwrite: true,
  autofix: true,
  mask: Number,
  signed: true,
  scale: 2,
  thousandsSeparator: ' ',
  radix: ',',
};

/**
 * Celé kladné číslo, bez oddělovačů tisíců.
 */
export const UnsignedFloatNumber = {
  overwrite: true,
  autofix: true,
  mask: Number,
  signed: false,
  scale: 2,
  thousandsSeparator: '',
  radix: ',',
};

/**
 * Celé kladné číslo, bez oddělovačů tisíců.
 */
export const UnsignedFloatNumberThSep = {
  overwrite: true,
  autofix: true,
  mask: Number,
  signed: false,
  scale: 2,
  thousandsSeparator: ' ',
  radix: ',',
};

/**
 * Měna na dvě desetinná místa, včetně kladné i záporné.
 */
export const SignedCurrency = {
  autofix: true,
  mask: [
    { mask: '' },
    {
      mask: 'N Kč',
      lazy: false,
      blocks: {
        N: {
          mask: Number,
          placeholderChar: 'HH',
          signed: true,
          scale: 2,
          thousandsSeparator: ' ',
          radix: ',',
          unmask: true,
        },
      },
    },
  ],
};

/**
 * Měna na dvě desetinná místa, jen kladné.
 */
export const UnsignedCurrency = {
  autofix: true,
  mask: [
    { mask: '' },
    {
      mask: 'N Kč',
      lazy: false,
      blocks: {
        N: {
          mask: Number,
          placeholderChar: 'HH',
          signed: false,
          scale: 2,
          thousandsSeparator: ' ',
          radix: ',',
          unmask: true,
        },
      },
    },
  ],
};

/**
 * Měna na celé číslo, včetně kladné i záporné.
 */
export const SignedIntCurrency = {
  autofix: true,
  mask: [
    { mask: '' },
    {
      mask: 'N Kč',
      lazy: false,
      blocks: {
        N: {
          mask: Number,
          placeholderChar: 'HH',
          signed: true,
          scale: 0,
          thousandsSeparator: ' ',
          radix: ',',
          unmask: true,
        },
      },
    },
  ],
};

/**
 * Měna na celé číslo, jen kladné.
 */
export const UnsignedIntCurrency = {
  autofix: true,
  mask: [
    { mask: '' },
    {
      mask: 'N Kč',
      lazy: false,
      blocks: {
        N: {
          mask: Number,
          placeholderChar: 'HH',
          signed: false,
          scale: 0,
          thousandsSeparator: ' ',
          radix: ',',
          unmask: true,
        },
      },
    },
  ],
};